import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Apollo } from 'apollo-angular';
import {
  PaymentGatewayTypeOption,
  PaymentMethodOption,
} from '@shared/models/payment-catalog.model';
import {
  GET_PAYMENT_GATEWAY_TYPES,
  GET_PAYMENT_METHODS,
} from '@shared/graphql/payment-catalog.graphql';

@Injectable({ providedIn: 'root' })
export class PaymentCatalogService {
  constructor(private apollo: Apollo) {}

  getPaymentMethods(): Observable<PaymentMethodOption[]> {
    return this.apollo
      .query<{ paymentMethods: PaymentMethodOption[] }>({
        query: GET_PAYMENT_METHODS,
        fetchPolicy: 'network-only',
      })
      .pipe(map((res) => res.data.paymentMethods));
  }

  getPaymentGatewayTypes(tenantId: string): Observable<PaymentGatewayTypeOption[]> {
    return this.apollo
      .query<{ paymentGatewayTypes: PaymentGatewayTypeOption[] }>({
        query: GET_PAYMENT_GATEWAY_TYPES,
        variables: { tenantId },
        fetchPolicy: 'network-only',
      })
      .pipe(map((res) => res.data.paymentGatewayTypes));
  }
}
